import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DeleteRecordingPrompt({
  onConfirm,
  onReject,
  hasVoicemail
}) {
  const LANG_KEY = hasVoicemail ? 'conversations-calling-message.timeline-call-metadata.call-voicemail.delete-recording' : 'conversations-calling-message.timeline-call-metadata.call-recording.delete-recording';
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_KEY}.title`
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${LANG_KEY}.body`
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onConfirm,
        use: "danger",
        "data-selenium-test": "delete-recording-button",
        "data-test-id": "delete-recording-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_KEY}.confirm`
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onReject,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_KEY}.cancel`
        })
      })]
    })]
  });
}
DeleteRecordingPrompt.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  hasVoicemail: PropTypes.bool
};